/* global axios */
const base = accountId => `/api/v1/accounts/${accountId}/relay_voice`;

export const getVoiceIdentity = accountId =>
  axios.get(`${base(accountId)}/me`).then(r => r.data);

export const getVoiceSession = accountId =>
  axios.get(`${base(accountId)}/session`).then(r => r.data);

export const getCallAccess = accountId =>
  axios.get(`${base(accountId)}/call_access`).then(r => r.data);

// scope: 'mine' (own extension) or 'all' (administrators and team leads).
export const getCalls = (accountId, params = {}) =>
  axios.get(`${base(accountId)}/calls`, { params }).then(r => r.data);

export const getCall = (accountId, callId) =>
  axios.get(`${base(accountId)}/calls/${callId}`).then(r => r.data);

export const getCallAnnotation = (accountId, callId) =>
  axios.get(`${base(accountId)}/calls/${callId}/annotation`).then(r => r.data);

export const saveCallAnnotation = (accountId, callId, annotation) =>
  axios
    .put(`${base(accountId)}/calls/${callId}/annotation`, annotation)
    .then(r => r.data);

export const postCallSummary = (accountId, summary) =>
  axios.post(`${base(accountId)}/calls/summary`, summary).then(r => r.data);

export const matchContacts = (accountId, numbers) =>
  axios
    .get(`${base(accountId)}/contact_matches`, { params: { numbers } })
    .then(r => r.data.data);

export const getColleagues = accountId =>
  axios.get(`${base(accountId)}/directory`).then(r => r.data.data);

export const reprovisionAgent = (accountId, userId) =>
  axios
    .post(`${base(accountId)}/agents/${userId}/reprovision`)
    .then(r => r.data);
